// AI Generated
import { Component, OnInit } from '@angular/core';
import { LoginService } from '@client/app/core/services/login/login.service';
import { StateService } from '@uirouter/core';
import { MonUIRouterTransitionService } from '@monsido/services/ui-router-transition-service/ui-router-transition-service';

@Component({
    selector: 'login',
    template: ``,
    standalone: false,
})
export class LoginComponent implements OnInit {

    constructor (
        private loginService: LoginService,
        private stateService: StateService,
        private uiRouterTransitionService: MonUIRouterTransitionService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        if (this.loginService.isLoggedIn()) {
            this.uiRouterTransitionService.onTransitionFinished(
                () => {
                    this.stateService.go('base.dashboard');
                },
            );
            return;
        }
        window.location.href = this.loginService.getAuthorizeUrl();
    }
}
